import { deleteToken, getToken, Messaging, onMessage, Unsubscribe } from '@angular/fire/messaging';
import { DataService, SubscribeForNotificationsType } from '../data/src';
import { ServiceWorkerPushAdapterBase } from './service-worker-push-adapter';
import { PushAdapterSettings } from '../models/notifications.model';

export class FirebasePushAdapter extends ServiceWorkerPushAdapterBase<string> {
  public static messaging: Messaging;

  constructor(
    coreDataService: DataService,
    channelIdentifier: string,
    serviceWorkerUrl: string,
    settings: PushAdapterSettings,
    clientIdentifier: string
  ) {
    super(
      SubscribeForNotificationsType.GoogleFirebase,
      coreDataService,
      channelIdentifier,
      serviceWorkerUrl,
      settings,
      clientIdentifier
    );
    this.setInitState();
  }

  private async setInitState() {
    this.notifyStateChanged(false, !(await this.isDenied()));
  }

  public static async isAvailable(): Promise<boolean> {
    return !!this.messaging;
  }

  protected override async getCurrentSubscription(reg: ServiceWorkerRegistration): Promise<string> {
    return null;
  }

  private messageUnsubscribe: Unsubscribe;
  private unsubscribeOnMessage() {
    if (this.messageUnsubscribe) {
      this.messageUnsubscribe();
      this.messageUnsubscribe = null;
    }
  }

  protected override async subscribeCore(reg: ServiceWorkerRegistration): Promise<string> {
    this.unsubscribeOnMessage();
    const token = await getToken(FirebasePushAdapter.messaging, {
      serviceWorkerRegistration: reg,
    });
    if (token) {
      this.messageUnsubscribe = onMessage(FirebasePushAdapter.messaging, async (payload) =>
        this.showNotification(reg, payload)
      );
    }
    return token;
  }

  protected override onBackgroundMessageReceived(reg: ServiceWorkerRegistration, payload: any): void {
    this.showNotification(reg, payload);
  }

  private async showNotification(reg: ServiceWorkerRegistration, payload: any): Promise<void> {
    let data = await this.resolveIfPromise(payload.data);
    if (this.settings.onNotificationReceived) {
      const modifiedPayloadData = this.settings.onNotificationReceived(data);
      if (modifiedPayloadData) {
        data = modifiedPayloadData;
      }
    }
    data.data = JSON.stringify(data);
    let title: string = data.title;
    if (!title) {
      title = '<Kein Titel>';
    }
    reg.showNotification(title, data);
  }

  private async resolveIfPromise<T>(value: T | Promise<T>): Promise<T> {
    if (value && typeof (value as any).then === 'function') {
      // Es ist ein Promise (inkl. ZoneAwarePromise)
      return await value;
    }
    // Kein Promise, einfach zurückgeben
    return value;
  }

  protected override async isGranted(): Promise<boolean> {
    //return typeof Notification !== 'undefined' && Notification.permission === 'granted';
    return new Promise((resolve) =>
      resolve(typeof Notification !== 'undefined' && Notification.permission === 'granted')
    );
  }

  protected override async isDenied(): Promise<boolean> {
    //return typeof Notification === 'undefined' || Notification.permission === 'denied';
    return new Promise((resolve) =>
      resolve(typeof Notification !== 'undefined' && Notification.permission === 'denied')
    );
  }

  protected override async unsubscribeCore(subscription: string): Promise<void> {
    await deleteToken(FirebasePushAdapter.messaging);
    this.unsubscribeOnMessage();
  }

  protected override async getProviderDefinition(subscription: string): Promise<object> {
    return { token: subscription };
  }
}
